<ng-container>
  <app-dialog
    *ngIf="!isColumnLayout"
    [dialogType]="dialogType"
    [primaryActionText]="primaryActionText"
    [secondaryActionText]="secondaryActionText"
    [hideCloseButton]="!dismissible"
    [preventCloseOnEsc]="!dismissible"
    customClass="growth-canvas"
    [footerText]="footerText"
    [htmlFooter]="true"
    [actionLeadText]="actionLeadText"
    [htmlActionLead]="true"
    [htmlPrimaryAction]="true"
    [htmlSecondaryAction]="true"
    [centerActions]="!secondaryActionText"
    [trackingObject]="trackingObject"
    [trackingScreenName]="trackingScreenName"
    [primaryActionTrackingAdditionalProperties]="
      primaryActionTrackingAdditionalProperties
    "
    [secondaryActionTrackingAdditionalProperties]="
      secondaryActionTrackingAdditionalProperties
    "
    (onPrimaryAction)="onPrimaryAction()"
    (onSecondaryAction)="onSecondaryAction()"
  >
    <div
      *ngIf="canvas"
      class="growth-dialog"
      [ngClass]="{ 'has-image': !!imgSrc }"
    >
      <ng-container [ngSwitch]="!!imgSrc">
        <ng-container *ngSwitchCase="true">
          <div class="growth-img-container">
            <img class="growth-img" [src]="imgSrc" [attr.alt]="headerLabel" />
          </div>

          <div class="growth-header">
            <h2 class="header-text">
              {{ headerLabel }}
            </h2>

            <div *ngIf="planLevel" class="plan-info">
              <app-premium-icon class="premium-icon"></app-premium-icon>

              {{ planLevel }}
            </div>
          </div>
        </ng-container>

        <ng-container *ngSwitchDefault>
          <div class="growth-img-container">
            <div *ngIf="planLevel" class="plan-info">
              <app-premium-icon class="premium-icon"></app-premium-icon>

              {{ planLevel }}
            </div>

            <h2 class="header-text">
              {{ headerLabel }}
            </h2>
          </div>
        </ng-container>
      </ng-container>

      <div
        *ngIf="subtitle"
        class="subtitle"
        [innerHTML]="subtitle | safe: 'html'"
      ></div>

      <div
        *ngIf="bodyText"
        class="growth-text"
        [innerHTML]="bodyText | safe: 'html'"
      ></div>

      <app-checkmark-list
        *ngIf="growthHighlights?.size > 0"
        class="checkmark-list"
        [items]="growthHighlights"
      >
      </app-checkmark-list>
    </div>
  </app-dialog>

  <app-dialog
    *ngIf="isColumnLayout"
    customClass="opt-out-trial"
    [dialogType]="dialogType"
    [trackingScreenName]="trackingScreenName"
    [trackingObject]="trackingObject"
    [hideCloseButton]="true"
    [preventCloseOnEsc]="true"
    [hideActions]="true"
  >
    <div class="opt-out-trial">
      <div
        *ngIf="imgSrc"
        [ngStyle]="{ 'background-image': 'url(' + imgSrc + ')' }"
        class="left-image"
      ></div>
      <div *ngIf="canvas" class="growth-dialog has-image">
        <div class="growth-header">
          <h2 class="header-text">
            {{ headerLabel }}
          </h2>

          <div *ngIf="planLevel" class="plan-info">
            <app-premium-icon class="premium-icon"></app-premium-icon>

            {{ planLevel }}
          </div>
        </div>

        <div
          *ngIf="subtitle"
          class="subtitle"
          [innerHTML]="subtitle | safe: 'html'"
        ></div>

        <div
          *ngIf="bodyText"
          class="growth-text"
          [innerHTML]="bodyText | safe: 'html'"
        ></div>

        <app-checkmark-list
          *ngIf="growthHighlights?.size > 0"
          class="checkmark-list"
          [items]="growthHighlights"
        >
        </app-checkmark-list>

        <div *ngIf="ctaPlans" class="plan-options">
          <div
            *ngFor="let plan of ctaPlans"
            class="plan-button"
            [class.plan-selected]="plan === selectedPlan"
            (click)="selectPlan(plan)"
          >
            <div class="plan-subtitle">
              {{ plan.subtitle }}
            </div>
            <div class="plan-title">
              {{ plan.title }}
            </div>
            <app-icon
              *ngIf="plan === selectedPlan"
              class="plan-checkmark"
              [icon]="selectedIcon"
            >
            </app-icon>
            <div *ngIf="plan.highlight" class="plan-highlight">
              {{ plan.highlight }}
            </div>
          </div>
        </div>

        <div class="flex-spacer"></div>

        <div
          *ngIf="actionLeadText"
          class="action-lead"
          [innerHTML]="actionLeadText | safe: 'html'"
        ></div>

        <button
          type="button"
          class="action primary-action vibrant-cta"
          data-e2e-id="primary-dialog-action"
          trackable
          [trackingObject]="trackingObject"
          [trackingAction]="primaryActionTapped"
          [trackingAdditionalProperties]="
            primaryActionTrackingAdditionalProperties
          "
          [innerHTML]="primaryActionText | safe: 'html'"
          appFitText
          (click)="onPrimaryAction()"
        ></button>
      </div>
    </div>
  </app-dialog>
</ng-container>
